import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-save-success',
  standalone: true,
  imports: [MatDialogModule,CommonModule],
  templateUrl: './save-success.component.html',
  styleUrl: './save-success.component.scss'
})
export class SaveSuccessComponent {
  message: string = ""
  title:string=""
  action:string=""
  actionType: string="add"
  cancelButtonText = "Cancel"
  modalName:string = ""
  saveTimeOnly:boolean=true;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<SaveSuccessComponent>) {
    if (data) {
      this.message = data.message;
      this.title= data.title;
      this.action = data.actionType
      this.modalName = data.modalName
      this.saveTimeOnly=data?.timeOnly;
    }
    this.dialogRef.updateSize('300vw','300vw')
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
